import {useEffect} from 'react';

import useUpdateMapSizeCallback from './useUpdateMapSizeCallback';

export default function useUpdateMapSizeOnRender(dispatch) {
	const updateMapSize = useUpdateMapSizeCallback(dispatch, undefined, false);
	useEffect(updateMapSize, [updateMapSize]);
}
